// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "motionplan/v1/motionplan.proto" (package "motionplan.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Offline RDK FK for motion-plan JSON.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Transform } from "../../common/v1/common";
/**
 * @generated from protobuf message motionplan.v1.ComputePlanFramesRequest
 */
export interface ComputePlanFramesRequest {
    /**
     * Permission scope.
     *
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: bytes plan_content = 2;
     */
    planContent: Uint8Array;
}
/**
 * @generated from protobuf message motionplan.v1.ComputePlanFramesResponse
 */
export interface ComputePlanFramesResponse {
    /**
     * @generated from protobuf field: repeated motionplan.v1.PlanStep steps = 1;
     */
    steps: PlanStep[];
}
/**
 * One trajectory step. Per-frame uuids stay stable so scrub updates entities in place.
 *
 * @generated from protobuf message motionplan.v1.PlanStep
 */
export interface PlanStep {
    /**
     * @generated from protobuf field: repeated viam.common.v1.Transform transforms = 1;
     */
    transforms: Transform[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ComputePlanFramesRequest$Type extends MessageType<ComputePlanFramesRequest> {
    constructor() {
        super("motionplan.v1.ComputePlanFramesRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "plan_content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.ComputePlanFramesRequest
 */
export const ComputePlanFramesRequest = new ComputePlanFramesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputePlanFramesResponse$Type extends MessageType<ComputePlanFramesResponse> {
    constructor() {
        super("motionplan.v1.ComputePlanFramesResponse", [
            { no: 1, name: "steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlanStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.ComputePlanFramesResponse
 */
export const ComputePlanFramesResponse = new ComputePlanFramesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanStep$Type extends MessageType<PlanStep> {
    constructor() {
        super("motionplan.v1.PlanStep", [
            { no: 1, name: "transforms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Transform }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.PlanStep
 */
export const PlanStep = new PlanStep$Type();
/**
 * @generated ServiceType for protobuf service motionplan.v1.MotionPlanService
 */
export const MotionPlanService = new ServiceType("motionplan.v1.MotionPlanService", [
    { name: "ComputePlanFrames", options: {}, I: ComputePlanFramesRequest, O: ComputePlanFramesResponse }
]);
